import { IconProps } from "./types";

export default function TshirtIcon({ className }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.2053 3.18701H6.93646C6.62098 3.18701 6.31841 3.31234 6.09533 3.53542L2.69231 6.93844C2.20646 7.42429 2.23209 8.21955 2.74821 8.67311L6.03943 11.5654C6.29643 11.7912 6.44374 12.1168 6.44374 12.4589V19.6057C6.44374 20.2627 6.97631 20.7952 7.63327 20.7952H13.2053"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <path
        d="M11.7969 3.18701H18.0657C18.3812 3.18701 18.6838 3.31234 18.9069 3.53542L22.3099 6.93844C22.7957 7.42429 22.7701 8.21955 22.254 8.67311L18.9628 11.5654C18.7058 11.7912 18.5585 12.1168 18.5585 12.4589V19.6057C18.5585 20.2627 18.0259 20.7952 17.3689 20.7952H11.7969"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <line
        x1="6.48272"
        y1="6.28564"
        x2="6.48272"
        y2="15.8645"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <path
        d="M18.5583 6.28564L18.5583 15.8645"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0852 4.96156C13.1602 5.88654 11.6606 5.88654 10.7356 4.96156C10.2477 4.4737 10.0172 3.82597 10.0439 3.18701H8.55621C8.52999 4.20668 8.90598 5.23478 9.68417 6.01297C11.1898 7.51862 13.631 7.51862 15.1366 6.01297C15.9148 5.23478 16.2908 4.20668 16.2646 3.18701H14.7769C14.8036 3.82597 14.5731 4.4737 14.0852 4.96156Z"
        fill="currentColor"
      />
    </svg>
  );
}
